export default __webpack_public_path__ + "img/bubble-yellow.5bebb620.svg";